/******************************************************************************
 *** BgtMbsdsExpndSubRsdocMng ** 운영비 지출결의서 관리 * 여입 결의서, 자료제출 결의서 작성
*******************************************************************************/
import React from "react";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Util from "@/js/common/Util";
import Button from "@/js/common/ui/Button";
import TextBox from "@/js/common/ui/input/TextBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import NumberTextBox from "@/js/common/ui/input/NumberTextBox";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "../../common/DialogTitleBar";
import BgtEvdncDialog from "./dialog/BgtEvdncDialog";
import * as Atom from "@/js/common/Atom";
import { useRecoilValue } from "recoil";
import BudgetFile from "../budgetFileBox/BudgetFile";
import { budgetFilesProps } from "@/js/common/types/types";
import BgtMbsdsEvdncList from "./BgtMbsdsEvdncList";
import BgtMbsdsExpndRsdocList from "./BgtMbsdsExpndRsdocList";
import BgtMbsdsExpndListViewDialog from "./dialog/BgtMbsdsExpndListViewDialog";
import BgtMbsdsExpndViewDialog from "./dialog/BgtMbsdsExpndViewDialog";
import AtrzLineBox from "../bgtovrl/dialog/AtrzLineBox";

const BgtMbsdsExpndSubRsdocMng = () => {
    // 기본 사용자/검색 조건
    const userInfo = useRecoilValue(Atom.userInfo);
    const isEvdncUse = userInfo.sysEvdncB1Yn === "Y";
    const [upOgnzCd        , setUpOgnzCd        ] = React.useState<string>(userInfo.upOgnzCd);      // 상위조직코드(본부)
    const [ognzCd          , setOgnzCd          ] = React.useState<string>(userInfo.ognzCd  );      // 조직코드(지부)
    const [acntgYear       , setAcntgYear       ] = React.useState<string>(Util.getNowAcntgYear()); // 회계연도
    const [searchAtrzSttsCd, setSearchAtrzSttsCd] = React.useState<string>("");                     // 진행상태(검색)

    // 지출결의서 입력
    const [mbsdsExpndDocId, setMbsdsExpndDocId] = React.useState<string>(""); // 결의서 문서 ID
    const [expndRsdocNo   , setExpndRsdocNo   ] = React.useState<string>(""); // 결의서 문서번호
    const [expndRsdocSeCd , setExpndRsdocSeCd ] = React.useState<string>(isEvdncUse ? "" : "03"); // 결의서 구분(일반[01], 무증빙[02], 여입[03], 자료제출[04])
    const [implDt         , setImplDt         ] = React.useState<string>(""); // 행위년월일(집행일자)(YYYYMMDD)
    const [bgtSbjct1stCd  , setBgtSbjct1stCd  ] = React.useState<string>(""); // 1차 코드(관)
    const [bgtSbjct2stCd  , setBgtSbjct2stCd  ] = React.useState<string>(""); // 2차 코드(항)
    const [bgtSbjct3stCd  , setBgtSbjct3stCd  ] = React.useState<string>(""); // 3차 코드(목)
    const [abstrCn        , setAbstrCn        ] = React.useState<string>(""); // 적요
    const [memo           , setMemo           ] = React.useState<string>(""); // 메모
    const [implAmt        , setImplAmt        ] = React.useState<string>(""); // 집행금액
    const [atrzSttsCd     , setAtrzSttsCd     ] = React.useState<string>("00"); // 결재상태정보
    const [atrzOpnnCn     , setAtrzOpnnCn     ] = React.useState<string>(""); // 반려사유(결재의견)
    const [availAmount    , setAvailAmount    ] = React.useState<string>("");   // 집행 가능 금액(표시)
    const [listLine       , setListLine       ] = React.useState<any[]>([]);  // 결재 라인 정보
    const [openLine       , setOpenLine       ] = React.useState<boolean>(false); // 기본 펼침/접힘

    // 파일(결의서)
    const [mbsdsExpndFiles, setMbsdsExpndFiles] = React.useState<File[]>([]);
    const [savedMbsdsExpndFiles, setSavedMbsdsExpndFiles] = React.useState<budgetFilesProps[]>([]);

    // 연결 지출결의서 문서
    const [lnkgMbsdsExpndDocId, setLnkgMbsdsExpndDocId] = React.useState<string>(""); // 연결 지출결의서 문서 ID
    const [lnkgExpndRsdocNo   , setLnkgExpndRsdocNo   ] = React.useState<string>(""); // 연계 지출결의서 문서번호
    const [linkDocFindModal   , setLinkDocFindModal   ] = React.useState<boolean>(false); // 연결 지출결의서 찾기 모달
    const [mbsdsExpndModalOpen, setMbsdsExpndModalOpen] = React.useState<boolean>(false); // 지출결의서 상세정보 모달

    // 지출증빙 내역서
    const [mbsdsEvdncModalOpen, setMbsdsEvdncModalOpen] = React.useState<boolean>(false); // 지출증빙내역서 모달 오픈
    const [mbsdsEvdncYn, setMbsdsEvdncYn] = React.useState<string>("N"); // 지출증빙내역 유무
    const [mbsdsEvdncDelYn, setMbsdsEvdncDelYn] = React.useState<string>("N"); // 지출증빙내역 삭제 여부
    const [sumUseAmt   , setSumUseAmt   ] = React.useState<string>("0"); // 지출증빙 사용금액 합계
    const [expndEvdncId, setExpndEvdncId] = React.useState<string>("");

    // 재조회 트리거
    const [callTime, setCallTime] = React.useState<Date>(new Date());
    const [callTime1, setCallTime1] = React.useState<Date>(new Date()); // 임시저장 시 문서번호 재조회용

    // 지출결의서 상세정보 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/mbsds/expnd/select-bgt-mbsds-expnd-rsdoc-dtl.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                mbsdsExpndDocId: mbsdsExpndDocId
            },
            onSuccessFn: (res: any) => {
                if (Util.isNotEmpty(res.result.item)) {
                    const item = res.result.item;
                    const listSum = res.result.listSum;
                    setMbsdsExpndDocId(item.mbsdsExpndDocId);
                    setExpndRsdocNo(item.expndRsdocNo);
                    setExpndRsdocSeCd(item.expndRsdocSeCd ); // 결의서 구분
                    setLnkgMbsdsExpndDocId(item.lnkgMbsdsExpndDocId); // 연결문서 ID
                    setLnkgExpndRsdocNo(item.lnkgExpndRsdocNo);  // 연결문서번호
                    setImplDt         (item.implDt         ); // 행위년월일(집행일자)
                    setBgtSbjct1stCd  (item.bgtSbjct1stCd  ); // 1차 코드(관)
                    setBgtSbjct2stCd  (item.bgtSbjct2stCd  ); // 2차 코드(항)
                    setBgtSbjct3stCd  (item.bgtSbjct3stCd  ); // 3차 코드(목)
                    // 여입결의서인 경우 금액 표시 변경: 금액은 항상 puls 금액으로 표시
                    if (res.result.item.expndRsdocSeCd === "03") {
                        setImplAmt((Number(item.implAmt) * -1).toString()); // 집행금액
                    } else {
                        setImplAmt        (item.implAmt        ); // 집행금액
                    }
                    setAbstrCn        (item.abstrCn        ); // 적요
                    setMemo           (item.memo           ); // 메모
                    setAtrzOpnnCn     (item.atrzOpnnCn     ); // 반려사유(결재의견)
                    setAtrzSttsCd     (item.atrzSttsCd     ); // 결재상태정보
                    setSumUseAmt      (listSum.sumUseAmt   ); // 지출증빙 사용금액 합계
                    setListLine       (res.result.listLine);  // 결재 라인리스트
                    setAvailAmount    (res.result.lnkgItem.implAmt); // 연결 문서의 사용금액

                    // 첨부파일
                    setSavedMbsdsExpndFiles(res.result.listFile);
                }
                AppContext.hideSpinner();
            },
        });
    }, [mbsdsExpndDocId, callTime1]);

    // 입력 폼 초기화: 신규 작성/저장/삭제 후 상태 리셋
    const doReset = () => {
        setMbsdsExpndDocId(""); // 지출결의서 문서 ID
        setExpndRsdocNo   (""); // 지출결의서 문서 번호
        setExpndRsdocSeCd (isEvdncUse ? "" : "03"); // 지출결의서 구분코드
        setImplDt         (""); // 행위년월일 (YYYYMMDD)
        setBgtSbjct1stCd  (""); // 1차 코드(관)
        setBgtSbjct2stCd  (""); // 2차 코드(항)
        setBgtSbjct3stCd  (""); // 3차 코드(목)
        setAbstrCn        (""); // 적요
        setMemo           (""); // 메모
        setImplAmt        (""); // 집행금액
        setAtrzSttsCd     ("00"); // 상태정보
        setAvailAmount    ("0"); // 집행가능금액
        setLnkgMbsdsExpndDocId(""); // 연결 문서번호
        setLnkgExpndRsdocNo(""); // 연결 문서번호

        setMbsdsExpndFiles     ([]); // 저장할 파일
        setSavedMbsdsExpndFiles([]); // 저장된 파일
    };

    // 문서 ID 변경 시 드롭존 초기화
    React.useEffect(() => {
        setMbsdsExpndFiles([]);
    }, [mbsdsExpndDocId]);

    // 필수 입력사항 체크
    function checkValue() {
        if (Util.isEmpty(expndRsdocSeCd)) { AppContext.openAlert({ title: "결의서 구분 확인", msg: "지출결의서 구분을 선택하세요." , icon: "warning" }); return false; }
        if (Util.isEmpty(implDt        )) { AppContext.openAlert({ title: "행위년월일 확인" , msg: "행위년월일을 선택하세요."      , icon: "warning" }); return false; }
        if (Util.isEmpty(bgtSbjct1stCd )) { AppContext.openAlert({ title: "예산과목 관 확인", msg: "예산과목 관 항목을 선택하세요.", icon: "warning" }); return false; }
        if (Util.isEmpty(bgtSbjct2stCd )) { AppContext.openAlert({ title: "예산과목 항 확인", msg: "예산과목 항 항목을 선택하세요.", icon: "warning" }); return false; }
        if (Util.isEmpty(bgtSbjct3stCd )) { AppContext.openAlert({ title: "예산과목 목 확인", msg: "예산과목 목 항목을 선택하세요.", icon: "warning" }); return false; }
        return true;
    }

    // 지출결의서 저장
    function doSave(atrzSttsCd: string) {
        let msgText = "임시저장";
        let cfmMsg  = "";

        // 지출증빙내역서 클릭 - 지출결의서 Insert 후 지출증빙내역서 모달 오픈
        if (atrzSttsCd === "00") {
            if (Util.isEmpty(mbsdsExpndDocId)) {
                cfmMsg = "지출결의서가 저장되지 않았습니다.\n"
            } else {
                setMbsdsEvdncModalOpen(true);
                return;
            }
        }

        // 필수입력사항 체크
        const isValidate = checkValue();
        if (!isValidate) return;

        // 작성완료 필수입력 확인
        if (atrzSttsCd === "02") {
            if (Util.isEmpty(implAmt)) { AppContext.openAlert({ title: "금액 확인", msg: "금액을 입력하세요.", icon: "warning" }); return; }
            if (Number(Util.uncomma(availAmount)) - Number(Util.uncomma(implAmt)) < 0) {
                AppContext.openAlert({ title: "집행금액 확인",
                    msg: "집행금액[" + Util.comma(implAmt) + "]이 " + "집행가능금액[" + Util.comma(availAmount) + "]보다 큽니다.", icon: "warning" }); return;
            }

            if (Util.isEmpty(abstrCn)) { AppContext.openAlert({ title: "적요 확인", msg: "적요를 입력하세요.", icon: "warning" }); return; }

            // 첨부파일 필수
            if (isEvdncUse && mbsdsEvdncYn === "N") {   // 지출증빙내역서가 없는 경우
                // 저장된 파일 또는 저장할 파일이 없을 경우
                if (Util.isEmpty(mbsdsExpndFiles) && savedMbsdsExpndFiles.length === 0) { AppContext.openAlert({ title: "첨부파일 확인", msg: "지출결의서 첨부파일을 등록하세요", icon: "warning" }); return; }
            }

            msgText = "작성완료";
        }

        // 금액 설정: 여입결의서는 금액을 마이너스로 입력
        let newImplAmt = Util.uncomma(implAmt) === "" ? 0 : Number(Util.uncomma(implAmt));
        if (expndRsdocSeCd === "03") {
            if (newImplAmt > 0) {
                newImplAmt = -1 * newImplAmt
            }
        }

        AppContext.openAlert({
            title: "지출결의서 확인",
            msg: cfmMsg + "지출결의서를 " + msgText + "하시겠습니까?",
            icon: "question",
            closeText: "취소",
            confirmText: msgText,
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url: "system/bgt/mbsds/expnd/save-bgt-mbsds-expnd-rsdoc.do",
                    methodType: "post",
                    isMultipart: true,
                    paramData: {
                        mbsdsExpndDocId: mbsdsExpndDocId, // 지출결의서 문서 ID
                        expndRsdocSeCd : expndRsdocSeCd , // 지출결의서 구분코드
                        lnkgMbsdsExpndDocId: lnkgMbsdsExpndDocId, // 연결문서 ID
                        orgCd          : ognzCd         , // 조직코드
                        implDt         : implDt         , // 행위년월일 (YYYYMMDD)
                        acntgYear      : Util.getAcntgYear(implDt), // 회계연도
                        bgtSbjct1stCd  : bgtSbjct1stCd  , // 1차 코드(관)
                        bgtSbjct2stCd  : bgtSbjct2stCd  , // 2차 코드(항)
                        bgtSbjct3stCd  : bgtSbjct3stCd  , // 3차 코드(목)
                        abstrCn        : abstrCn        , // 적요
                        memo           : memo           , // 메모
                        implAmt        : newImplAmt     , // 집행금액
                        atrzSttsCd     : atrzSttsCd === "00" ? "01" : atrzSttsCd, // 상태정보
                        budgetFiles    : mbsdsExpndFiles      , // 첨부파일
                        fileSeCd       : "A02"                , // 파일구분코드(운영비_지출결의서[A02])
                    },
                    onSuccessFn: (res: any) => {
                        AppContext.openAlert({
                            title: "지출결의서 저장",
                            msg: "지출결의서가 저장되었습니다.",
                            icon: "check",
                        });
                        // 지출결의서 Insert 후 문서 ID 설정
                        if (Util.isEmpty(mbsdsExpndDocId)) {
                            setMbsdsExpndDocId(res.result.mbsdsExpndDocId); // 지출결의서 문서 ID
                            if (atrzSttsCd === "00") setMbsdsEvdncModalOpen(true); // 지출증빙내역서 모달 오픈
                        } else if(atrzSttsCd === "01") {
                            setCallTime1(new Date());
                        }
                        setMbsdsEvdncDelYn("N"); // 증빙 삭제 여부
                        if (atrzSttsCd === "02") {
                            doReset(); // 작성완료인 경우 전체 초기화 처리
                        } else {
                            setMbsdsExpndFiles([]); // 저장할 파일 초기화
                        }
                        setCallTime(new Date());
                    },
                });
            },
        });
    };

    // 결의서 삭제 - 결의서 PK로 삭제 후 화면 리셋 및 목록 재조회
    const doDelete = () => {
        if (Util.isEmpty(mbsdsExpndDocId)) return;

        AppContext.openAlert({
            title: "삭제",
            msg: "지출결의서를 삭제하시겠습니까?",
            icon: "warning",
            confirmText: "삭제",
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url: "system/bgt/mbsds/expnd/delete-bgt-mbsds-expnd-rsdoc.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: { mbsdsExpndDocId: mbsdsExpndDocId },
                    onSuccessFn: () => {
                        AppContext.openAlert({
                            title: "지출결의서 삭제 완료",
                            msg: "지출결의서가 삭제 완료되었습니다.",
                            icon: "warning",
                        });
                        AppContext.hideSpinner();
                        doReset(); // 초기화
                        setCallTime(new Date());
                    },
                });
            },
        });
    };

    // 연결 문서찾기
    function doFindDocId() {
        if (Util.isEmpty(expndRsdocSeCd)) {
            AppContext.openAlert({
                title: "결의서 구분 확인",
                msg: "결의서 구분을 선택하세요.",
                icon: "warning"
            });
            return false;
        }
        setLinkDocFindModal(true); // 연결 지출결의서 찾기 모달 오픈
    }

    // 첨부파일 삭제할 경우 작성 중으로 상태정보 변경
    React.useEffect(() => {
        if (atrzSttsCd === "00" || atrzSttsCd === "01") return;

        // 작성완료
        if (atrzSttsCd === "02") {
            if (mbsdsEvdncYn === "N" && savedMbsdsExpndFiles.length === 0) {
                setAtrzSttsCd("01");
                // 상태정보 업데이트 처리
                AppContext.showSpinner();
                Axios.dataAccess({
                    url: "system/bgt/mbsds/expnd/update-bgt-mbsds-expnd-stts-cd.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        mbsdsExpndDocId: mbsdsExpndDocId,
                        atrzSttsCd: "01" // 작성 중
                    },
                    onSuccessFn: () => {
                        AppContext.hideSpinner();
                        setCallTime(new Date());
                    },
                });
            }
        }
    }, [atrzSttsCd, expndRsdocSeCd, mbsdsEvdncYn, savedMbsdsExpndFiles, mbsdsExpndDocId]);

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            {/* 타이틀 */}
            <div className="mt5">
                <span className="dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">운영비 {isEvdncUse ? "여입/추가 자료제출 관리" : "여입결의서 관리"}
                    <span className={`w100p fm-b fs16 ml10 ${isEvdncUse ? "fc007CE8" : "fcC0392B"}`}>{isEvdncUse ? "(증빙첨부 필수)" : "(증빙첨부 미사용)"}</span>
                </span>
                <div className="bdt3 bdc007bff pb10" />
            </div>

            {/* 검색 조건 */}
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC flxWrap gap14">
                    {/* 소속 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">본부</span>
                        <SelectBox value={upOgnzCd}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getUpOrgCodeArray("01")}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setUpOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    {/* 지부 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">지부</span>
                        <SelectBox value={ognzCd}
                            width={180} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getDownOrgCodeArray(upOgnzCd)}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">회계연도</span>
                        <SelectBox value={acntgYear}
                            width={120} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff" paddingRight={8}
                            codeArray={Util.getAcntgYearArray()}
                            placeholder="선택"
                            onChangeFunc={(data: string) => setAcntgYear(data)}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">진행상태</span>
                        <SelectBox  value={searchAtrzSttsCd}
                            width={140} height={36}
                            fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff"
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("UI_ATRZ_STTS_CD_01"))}
                            placeholder="전체" paddingRight={8}
                            onChangeFunc={(data: string) => setSearchAtrzSttsCd(data)}
                        />
                    </div>
                </div>
            </div>

            {/* 좌/우 */}
            <div className="dpFlx gap14 aiFs">
                {/* LEFT */}
                <div className="w360">
                    <div className="bd1d9d9d9 bdrd6 bgcWhite p15">
                        <div className="mb10">
                            <span className="fm-b fs16 fc007bff ls1 fw700">지출결의서 입력</span>
                            <span className="fm-b fs13 ls06 fc1A5276" style={{marginLeft: "77px"}}>{expndRsdocNo}</span>
                        </div>
                        
                        {atrzSttsCd === "05" && (
                        <AtrzLineBox
                            listLine={listLine}
                            open={openLine}
                            onToggle={() => setOpenLine((v) => !v)}
                        />)}

                        {/* 결의서 구분 */}
                        <div className="dpFlx flxdCol mb10">
                            <div className="h30 dpFlx aiE pb5">
                                <span className="fm-b fs13 ls06 fc111111">결의서 구분</span>
                            </div>
                            <div className="w320 h36 bd1d9d9d9 dpFlx aiC bsBdb" style={{backgroundColor: ["01", "02", "05"].includes(atrzSttsCd) || !isEvdncUse ? "#F6F6F6": "white"}}>
                                <div className="ml10">
                                    <label className="dpFlx csP">
                                        <input type="radio" value={"03"} checked={expndRsdocSeCd === "03"}
                                            onChange={(e) => {
                                                setExpndRsdocSeCd(e.target.value);
                                                setImplAmt(""); // 금액
                                                setImplDt(""); // 행위년월일
                                                setLnkgMbsdsExpndDocId(""); // 연결 문서 ID
                                                setAvailAmount  (""); // 집행가능금액
                                                setBgtSbjct1stCd(""); // 관
                                                setBgtSbjct2stCd(""); // 항
                                                setBgtSbjct3stCd(""); // 목
                                                setAbstrCn      (""); // 적요
                                            }}
                                            style={{transform: "scale(1.2)"}}
                                            disabled={["01", "02", "05"].includes(atrzSttsCd) || !isEvdncUse ? true : false}   // 작성중(01), 작성완료(02), 반려(05): 임시저장 이후 수정불가
                                        />
                                        <div className="mb2">
                                            <span className="fm-b c333333 ls1 fs14 ml3" style={{fontWeight: expndRsdocSeCd === "03" ? "700" : ""}}>여입 결의서</span>
                                        </div>
                                    </label>
                                </div>
                                <div className="ml10 ml20 aiC">
                                    <label className="dpFlx csP">
                                        <input type="radio" value={"04"} checked={expndRsdocSeCd === "04"}
                                            onChange={(e) => {
                                                setExpndRsdocSeCd(e.target.value);
                                                setImplAmt("0"); // 금액
                                                setImplDt(""); // 행위년월일
                                                setLnkgMbsdsExpndDocId(""); // 연결 문서 ID
                                                setAvailAmount  (""); // 집행가능금액
                                                setBgtSbjct1stCd(""); // 관
                                                setBgtSbjct2stCd(""); // 항
                                                setBgtSbjct3stCd(""); // 목
                                                setAbstrCn      (""); // 적요
                                            }}
                                            style={{transform: "scale(1.2)"}}
                                            disabled={["01", "02", "05"].includes(atrzSttsCd) || !isEvdncUse ? true : false}   // 작성중(01), 작성완료(02), 반려(05): 임시저장 이후 수정불가
                                        />
                                        <div className="mb2">
                                            <span className="fm-b c333333 ls1 fs14 ml3" style={{fontWeight: expndRsdocSeCd === "04" ? "700" : ""}}>자료제출 결의서</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* 연계문서 찾기 */}
                        <div className="dpFlx gap10 aiE mb10">
                            {/* 연결 문서번호 */}
                            <div className="flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">연결 문서번호</span>
                                </div>
                                <div className="w210 h36 aiC bsBdb bd1 bdcDDDDDD bdrd3 bgcF0F0F0 csP taC pt2 op70-hover" onClick={() => {
                                    if (Util.isNotEmpty(lnkgMbsdsExpndDocId)) {
                                        setMbsdsExpndModalOpen(true)
                                    }
                                }}>
                                    <span className="fm-c ls1 fs14 fc333333">{lnkgExpndRsdocNo}</span>
                                </div>
                            </div>

                            {/* 연결 문서찾기 */}
                            <div className="flx1">
                                <div className="w155 h36 dpFlx aiC bsBdb">
                                    <Button buttonName="연결 문서찾기"
                                        width={100} height={35}
                                        fontFamily="fm-b" fontSize={14} letterSpacing={-1} color="#fff"
                                        backgroundColor="#009999" borderRadius={6}
                                        buttonClass="dpFlx aiC jcC bd1 bdcForest"
                                        onClickFunc={() => doFindDocId()}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* 행위년월일 */}
                        <div className="dpFlx flxdCol mb10">
                            <div className="h30 dpFlx aiE pb5">
                                <span className="fm-b fs13 ls06 fc111111">행위년월일</span>
                            </div>
                            <DatePickerBox value={implDt}
                                width={320} height={36} fontSize={14}
                                fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                bgColor={["01", "02", "05"].includes(atrzSttsCd) && userInfo.ognzCd !== "00_000" ? "#F6F6F6": "white"}
                                textAlign="left"
                                calendarThemeColor={AppContext.themeColor}
                                disabled={["01", "02", "05"].includes(atrzSttsCd) && userInfo.ognzCd !== "00_000"}   // 작성중(01), 작성완료(02), 반려(05): 임시저장 이후 수정불가
                                onChange={(data: string) => setImplDt(data)}
                            />
                        </div>

                        {/* 관/항/목 */}
                        <div className="dpFlx mb10">
                            {/* 관 */}
                            <div className="dpFlx flxdCol flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">관</span>
                                </div>
                                <SelectBox value={bgtSbjct1stCd}
                                    width={100} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    background="#f6f6f6" paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt1CodeArray("02", ognzCd))}
                                    placeholder="선택"
                                    disabled={true}
                                    onChangeFunc={(data: string) => setBgtSbjct1stCd(data)}
                                />
                            </div>

                            {/* 항 */}
                            <div className="dpFlx flxdCol flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">항</span>
                                </div>
                                <SelectBox value={bgtSbjct2stCd}
                                    width={100} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    background="#f6f6f6" paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt2CodeArray(bgtSbjct1stCd, ognzCd))}
                                    placeholder="선택"
                                    disabled={true}
                                    onChangeFunc={(data: string) => setBgtSbjct2stCd(data)}
                                />
                            </div>

                            {/* 목 */}
                            <div className="dpFlx flxdCol flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">목</span>
                                </div>
                                <SelectBox  value={bgtSbjct3stCd}
                                    width={100} height={36}
                                    fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                    borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                    background="#f6f6f6" paddingRight={8}
                                    codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt3CodeArray(bgtSbjct2stCd, ognzCd))}
                                    placeholder="선택"
                                    disabled={true}
                                    onChangeFunc={(data: string) => setBgtSbjct3stCd(data)}
                                />
                            </div>
                        </div>

                        {/* 금액 + 집행 가능 금액 */}
                        <div className="dpFlx gap10 aiE mb10">
                            <div className="flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">금액 (원)</span>
                                </div>
                                <div className="w150 h36 bgcWhite dpFlx aiC bsBdb">
                                    <NumberTextBox value={implAmt}
                                        className={(mbsdsEvdncYn === "Y" || expndRsdocSeCd === "04") ? "bgcF0F0F0 w100p h36 bd1 bdrd2" : "w100p h36 bd1 bdrd2"}
                                        thousandsGroupStyle="thousand" thousandSeparator=","
                                        placeholder="0"
                                        fontSize={14} fontFamily="fm-c" letterSpacing={-1}
                                        onChange={(data: string) => setImplAmt(data)}
                                        inputClass={"taR mr10"}
                                        color="#007bff"
                                        disabled={(mbsdsEvdncYn === "Y" || expndRsdocSeCd === "04") ? true : false} // 지츨증빙내역서 유 or 자료제출 결의서
                                    />
                                </div>
                            </div>

                            <div className="flx1">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">집행 가능 금액</span>
                                </div>
                                <div className="w150 h36 bd1 bdcDDDDDD bdrd2 bgcF0F0F0 dpFlx aiC bsBdb">
                                    <NumberTextBox  value={availAmount}
                                        className="w100p h100p bd1 bdrd2 bgcF0F0F0"
                                        thousandsGroupStyle="thousand" thousandSeparator=","
                                        placeholder="0"
                                        fontSize={14} fontFamily="fm-c" letterSpacing={-1} color="#333"
                                        inputClass={"taR mr10"}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* 적요 */}
                        <div className="dpFlx flxdCol mb10">
                            <div className="h30 dpFlx aiE pb5">
                                <span className="fm-b fs13 ls06 fc111111">적요</span>
                            </div>
                            <TextBox value={abstrCn}
                                width={320} height={36} fontSize={14}
                                fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                style={{ backgroundColor: expndRsdocSeCd === "04" ? "#F6F6F6" : "#fff", padding: "0 12px" }}
                                placeholder="예) 12월 소모품 구입"
                                onChangeFunc={(text: string) => setAbstrCn(text)}
                                mode={expndRsdocSeCd === "04" ? "disabled" : ""}
                            />
                        </div>

                        <div className="dpFlx flxdCol mb10">
                            <div className="h30 dpFlx aiE pb5">
                                <span className="fm-b fs13 ls06 fc111111">메모</span>
                            </div>
                            <TextBox value={memo}
                                width={320} height={36} fontSize={14}
                                fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                                style={{ backgroundColor: "#fff", padding: "0 12px" }}
                                placeholder="메모를 입력하세요."
                                onChangeFunc={(text: string) => setMemo(text)}
                            />
                        </div>

                        <BgtMbsdsEvdncList
                            doSave                 = {doSave}                   // 지출결의서 저장
                            mbsdsExpndDocId        = {mbsdsExpndDocId}          // 지출결의서 문서 ID
                            setMbsdsEvdncModalOpen = {setMbsdsEvdncModalOpen}   // 지출증빙내역서 모달 오픈
                            setExpndEvdncId        = {setExpndEvdncId}          // 지출증빙내역서 ID
                            setMbsdsEvdncYn        = {setMbsdsEvdncYn}          // 지출증빙내역서 유무
                            setImplAmt             = {setImplAmt}               // 지출결의서 집행금액 셋팅
                            mbsdsEvdncDelYn        = {mbsdsEvdncDelYn}          // 지출증빙내역서 삭제 여부
                            callTime               = {callTime}
                        ></BgtMbsdsEvdncList>

                        {/* 반려 */}
                        {atrzSttsCd === "05" && (
                            <div className="dpFlx flxdCol">
                                <div className="h30 dpFlx aiE pb5">
                                    <span className="fm-b fs13 ls06 fc111111">반려 사유</span>
                                </div>
                                <div className="dpFlx aiFs">
                                    <div className="flxg1 bsBdb">
                                        <textarea
                                            value={atrzOpnnCn}
                                            className="w320 h70 bsBdb p10 bd1 bdcDFDFDF bdrd2 fm-c fs14 fc333333 ls1 bgcWhite rszN"
                                            maxLength={2000}
                                            placeholder=""
                                            onChange={(e) => setAtrzOpnnCn(e.target.value)}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* 첨부파일 */}
                        <BudgetFile
                            atrzSttsCd          = {atrzSttsCd}      // 상태정보
                            fileSeCd            = "A02"             // 운영비 지출결의서(A02)
                            savedBudgetFiles    = {savedMbsdsExpndFiles}
                            setSavedBudgetFiles = {setSavedMbsdsExpndFiles}
                            budgetFiles         = {mbsdsExpndFiles}
                            setBudgetFiles      = {setMbsdsExpndFiles}
                        />

                        <div className="bdt1 bdcDDDDDD mt15 mb15" />

                        <div className="dpFlx aiC jcSb gap10">
                            <Button buttonName="초기화"
                                width={80} height={40}
                                fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                                variant="styInitBtn" borderRadius={6}
                                buttonClass="dpFlx aiC jcC"
                                onClickFunc={() => doReset()}
                            />

                            {(atrzSttsCd === "01" || atrzSttsCd === "02" || atrzSttsCd === "05") &&
                                <Button buttonName="삭제"
                                    width={75} height={40}
                                    fontFamily="fm-b" fontSize={15} letterSpacing={-1}
                                    variant="styDeleteBtn" borderRadius={6}
                                    buttonClass="dpFlx aiC jcC"
                                    onClickFunc={doDelete}
                                />
                            }

                            {(atrzSttsCd === "00" || atrzSttsCd === "01") &&
                                <Button buttonName="임시저장"
                                        width={100} height={40}
                                        fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                                        variant="styTempBtn" borderRadius={6}
                                        buttonClass="dpFlx aiC jcC"
                                    onClickFunc={() => doSave("01")}
                                />
                            }

                            <Button buttonName="작성완료"
                                width={100} height={40}
                                fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                                variant="styCompleteBtn" borderRadius={6}
                                buttonClass="dpFlx aiC jcC"
                                onClickFunc={() => doSave("02")}
                            />
                        </div>
                    </div>
                </div>

                {/* RIGHT 지출결의서 목록 */}
                <div className="flx1">
                    <BgtMbsdsExpndRsdocList
                        ognzCd             = {ognzCd    } // 조직코드
                        acntgYear          = {acntgYear } // 회계연도
                        searchAtrzSttsCd   = {searchAtrzSttsCd} // 상태정보(검색)
                        setMbsdsExpndDocId = {setMbsdsExpndDocId} // 지출결의서 문서 ID Setting
                        prcsExpndRsdocSeCd = "02"   // 결의서 구분 검색 조건(여입, 자료제출)
                        callTime={callTime}
                    ></BgtMbsdsExpndRsdocList>
                </div>
            </div>

            {/* 지출증빙내역서 모달 */}
            <Modal modalOpen={mbsdsEvdncModalOpen} dim={true} visible={true}
                titleEl={<DialogTitleBar title="지출증빙내역서" backgroundColor={AppContext.themeColor} />}
                onCloseFunc={() => {
                    setExpndEvdncId("");
                    setMbsdsEvdncModalOpen(false);
                }}
            >
                <BgtEvdncDialog
                    mbsdsExpndDocId        = {mbsdsExpndDocId}         // 지출결의서 문서 ID
                    expndEvdncId           = {expndEvdncId}       // 지출증빙내역서 ID
                    setExpndEvdncId        = {setExpndEvdncId}    // 지출증빙내역서 ID 셋팅
                    acntgYear              = {Util.getAcntgYear(implDt)}  // 회계연도
                    setMbsdsEvdncModalOpen = {setMbsdsEvdncModalOpen}
                    setMbsdsEvdncDelYn     = {setMbsdsEvdncDelYn}         // 지출증빙내역서 삭제 여부
                    availAmount            = {availAmount}                // 집행가능금액
                    sumUseAmt              = {sumUseAmt}                  // 지출증빙내역서 사용금액 합계
                    isEvdncUse             = {isEvdncUse}                 // 증빙첨부 사용여부
                    setCallTime            = {setCallTime}
                />
            </Modal>

            {/* 연계 지출결의서 찾기 모달 */}
            <Modal modalOpen={linkDocFindModal} dim={true} visible={true}
                titleEl={<DialogTitleBar title="지출결의서 목록" />}
                onCloseFunc={() => {
                    setLinkDocFindModal(false);
                }}
            >
                <BgtMbsdsExpndListViewDialog
                    ognzCd                 = {ognzCd    }           // 조직코드
                    expndRsdocSeCd         = {expndRsdocSeCd}       // 결의서 구분 코드(여입 : 03, 자료제출 : 04)
                    setLinkDocFindModal    = {setLinkDocFindModal}  // 모달 오픈
                    setLnkgMbsdsExpndDocId = {setLnkgMbsdsExpndDocId} // 연결 지출결의서 문서 ID
                    setLnkgExpndRsdocNo    = {setLnkgExpndRsdocNo} // 연결 지출결의서 문서 번호
                    setImplDt              = {setImplDt}            // 행위년월일
                    setBgtSbjct1stCd       = {setBgtSbjct1stCd}     // 관
                    setBgtSbjct2stCd       = {setBgtSbjct2stCd}     // 항
                    setBgtSbjct3stCd       = {setBgtSbjct3stCd}     // 목
                    setAvailAmount         = {setAvailAmount}       // 집행가능금액
                    setAbstrCn             = {setAbstrCn}           // 적요
                />
            </Modal>

            {/* 연결 지출결의서 상세정보 모달 */}
            <Modal modalOpen={mbsdsExpndModalOpen} dim={true} visible={true}
                titleEl={<DialogTitleBar title="지출결의서 상세내용" />}
                onCloseFunc={() => {
                    setLnkgMbsdsExpndDocId("");
                    setMbsdsExpndModalOpen(false);
                }}
            >
                <div className="h700">
                    <BgtMbsdsExpndViewDialog
                        mbsdsExpndDocId        = {lnkgMbsdsExpndDocId}     // 지출결의서 문서 ID
                        setMbsdsExpndModalOpen = {setMbsdsExpndModalOpen}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default BgtMbsdsExpndSubRsdocMng;